import { DirectUpload } from "@rails/activestorage"

const forecast = {
  setup(graph_id, loading_id, error_id) {
    let obj = graph();

    obj.graphDiv = document.getElementById(graph_id);
    obj.loadingDiv = document.getElementById(loading_id);
    obj.errorDiv = document.getElementById(error_id);

    if (obj.graphDiv) {
      obj.reload();
    }

    return obj;
  }
}

export default forecast

function graph() {
  return {
    graphDiv: null,
    loadingDiv: null,
    errorDiv: null,
    initialized: false,

    search: '',
    traces: [],
    datasets: '',
    usages: {},
    ys: [],

    reload() {
      if (this.graphDiv && this.graphDiv.dataset.chartUrl) {
        this.setLoading(true);
        fetch(this.graphDiv.dataset.chartUrl)
          .then(response => response.json())
          .then(data => {
            if (!data.running) {
              if (data.error) {
                this.errorDiv.querySelector('#error-message').innerHTML = data.error;
                this.errorDiv.style.display = 'block';
                this.graphDiv.style.display = 'none';
              }
              else {
                this.errorDiv.style.display = 'none';
                this.graphDiv.style.display = 'block';
                if (this.initialized) {
                  Plotly.react(this.graphDiv, data, forecast_layout, { displayModeBar: false });
                }
                else {
                  Plotly.newPlot(this.graphDiv, data, forecast_layout, { displayModeBar: false });
                  this.initialized = true;
                }
              }

              this.setLoading(false);
            }
          })
      }
    },

    setLoading(loading) {
      if (this.loadingDiv) {
        this.loadingDiv.style.display = loading ? 'block' : 'none';
      }
    },

    purge() {
      Plotly.purge(this.graphDiv);
    },

    static(form, input) {
      this.setLoading(true);
      
      function urltoFile(url, filename, mimeType) {
        return (fetch(url)
            .then(function(res){return res.arrayBuffer();})
            .then(function(buf){return new File([buf], filename,{type:mimeType});})
        );
      }


      Plotly.toImage(this.graphDiv, {
        format: 'jpeg',
        width: 1280,
        height: 720
      }).then(url => {
        urltoFile(url, 'graph.jpg','image/jpeg').then(file => {
          const uploader = new DirectUpload(file, input.dataset.directUploadUrl);
          uploader.create((error, blob) => {
            if(error) {
              console.log('error', error);
            }
            else {
              // Add the <input type="hidden"> with the signature.
              const hiddenField = document.createElement('input')
              hiddenField.setAttribute('name', 'blob_signed_id')
              hiddenField.setAttribute('type', 'hidden');
              hiddenField.setAttribute('value', blob.signed_id);
              form.appendChild(hiddenField);

              form.submit();
            }
          });
        })
      })
    }
  }
}

const forecast_layout = {
  title: 'Forecast',
  xaxis: {
    rangeslider: true,
    rangeselector: {
      buttons: [
        {
          count: 1,
          label: '1m',
          step: 'month',
          stepmode: 'backward'
        },
        {
          count: 3,
          label: '3m',
          step: 'month',
          stepmode: 'backward'
        },
        {
          count: 6,
          label: '6m',
          step: 'month',
          stepmode: 'backward'
        },
        {
          step: 'all'
        }
      ]
    }
  },
  shapes: [
    {
      type: 'line',
      x0: new Date().toJSON().slice(0, 10),
      y0: 0,
      x1: new Date().toJSON().slice(0, 10),
      yref: 'paper',
      y1: 1,
      line: {
        color: 'grey',
        width: 1.5,
        dash: 'dot'
      }
    }
  ]  
}

